// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__246qw","success":"Tag_success__i6rOe","default":"Tag_default__25wgh"};